/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
export type infoAddDraftContainerInput = {
    clientMutationId?: string | null;
    ticketType: string;
    containerNumber: string;
    procedure?: string | null;
    containerType: string;
    terminalDate?: string | null;
    dischargeDate?: string | null;
    voyageSlug?: string | null;
    shippingLineSlug?: string | null;
    voyageName?: string | null;
    vesselSlug?: string | null;
    sourcePortCode?: string | null;
    destinationPortCode?: string | null;
    etd?: string | null;
    eta?: string | null;
    vesselName?: string | null;
    vesselShippingLineSlug?: string | null;
    imoNumber?: string | null;
};
export type DraftContainerAddMutationVariables = {
    input: infoAddDraftContainerInput;
};
export type DraftContainerAddMutationResponse = {
    readonly infoAddDraftContainer: {
        readonly clientMutationId: string | null;
    } | null;
};
export type DraftContainerAddMutation = {
    readonly response: DraftContainerAddMutationResponse;
    readonly variables: DraftContainerAddMutationVariables;
};



/*
mutation DraftContainerAddMutation(
  $input: infoAddDraftContainerInput!
) {
  infoAddDraftContainer(input: $input) {
    clientMutationId
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "infoAddDraftContainerPayload",
    "kind": "LinkedField",
    "name": "infoAddDraftContainer",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "clientMutationId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DraftContainerAddMutation",
    "selections": (v1/*: any*/),
    "type": "ApplicationCommand",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DraftContainerAddMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "0361bccf8164a934a157cbb944e98856",
    "id": null,
    "metadata": {},
    "name": "DraftContainerAddMutation",
    "operationKind": "mutation",
    "text": "mutation DraftContainerAddMutation(\n  $input: infoAddDraftContainerInput!\n) {\n  infoAddDraftContainer(input: $input) {\n    clientMutationId\n  }\n}\n"
  }
};
})();
(node as any).hash = '8a88d82582f1e5bca7f314fd840805cc';
export default node;
